import { List, ListItem, Typography } from "@mui/material";
import { Link } from "react-router-dom";

export const ParkRules = () => {
  return (
    <div className="page">
      <Typography
        gutterBottom
        sx={{ backgroundColor: "#ffee90", p: 2, mx: "0.7%" }}
      >
        Please read all our rules! This will lead to a better experience for
        everyone.
      </Typography>
      <List
        sx={{
          paddingTop: 0,
          listStyleType: "disc",
          pl: 2,
          "& .MuiListItem-root": {
            display: "list-item",
          },
        }}
      >
        <ListItem sx={{ pl: 0 }}>
          Do not take sticks or anything else from the forest. If every camper
          takes even a couple of sticks to start their fire or roast a
          marshmallow, the forest around the site starts being bare and less
          private. The Bruce Peninsula has very little topsoil and our trees and
          shrubs need nutrients created by decaying plant matter to survive.
          Please respect our forest and do not touch anything.
        </ListItem>
        <ListItem sx={{ pl: 0 }}>
          There are a lot of kids running and biking around the campground -
          keep them safe by driving slow. The speed limit within the park is 15
          km/h.
        </ListItem>
        <ListItem sx={{ pl: 0 }}>
          Check-out time is 11AM and check-in time is between 1PM - 10PM. Late
          arrivals after 10PM are not let in, and are still charged for the
          night. The purpose of this rule is to prevent people from arriving
          late at night and annoying other campsites while setting up their
          site.
        </ListItem>
        <ListItem sx={{ pl: 0 }}>
          Each campsite is designed for one household and one camping unit. We do not have large group
          campsites like some other campgrounds do.
        </ListItem>
        <ListItem sx={{ pl: 0 }}>
          Day visitors must register at the front office and leave by 10PM.
        </ListItem>
        <ListItem sx={{ pl: 0 }}>
          Quiet time is from 11PM - 7AM. Radios, TVs, and anything else making
          noise must be off at 11PM and voices must be kept down to a whisper.
        </ListItem>
        <ListItem sx={{ pl: 0 }}>
          The park is gated and no vehicles are let in through the gate between
          11PM and 7AM.
        </ListItem>
        <ListItem sx={{ pl: 0 }}>
          Please bag and tie all garbage and place it in the bear-proof bins
          located in the overflow parking area at the front of the park.
        </ListItem>
        <ListItem sx={{ pl: 0 }}>
          We have a <Link to="/barecampsite">"bare" campsite policy</Link>,
          which means keeping your site bare of food/drink and garbage to keep
          bears off of your site. A safe place for food related products is
          inside a locked car with windows up.
        </ListItem>

        <ListItem sx={{ pl: 0 }}>
          Fires are permitted at campsites in fire pits only. Fires must not be
          left unattended and they must be completely out when you go to bed.
        </ListItem>
        <ListItem sx={{ pl: 0 }}>
          Do not cut any trees or branches, peel bark or drive nails or hatchets
          into trees as this can kill them.
        </ListItem>
        <ListItem sx={{ pl: 0 }}>Abuse of wildlife is not tolerated.</ListItem>
        <ListItem sx={{ pl: 0 }}>
          Picking of wildflowers is not permitted.
        </ListItem>
        <ListItem sx={{ pl: 0 }}>
          Discharge of firearms or fireworks is not permitted.
        </ListItem>
        <ListItem sx={{ pl: 0 }}>
          Alcoholic beverages and cannabis may be consumed only at your
          campsite. Consumption is not permitted in campground common areas
          (such as roads, beach, playground, washrooms, or hiking trail).
        </ListItem>
        <ListItem sx={{ pl: 0 }}>
          Rowdiness, drunkenness, excessive noise, abusive or insulting
          language, and unruly behaviour are not permitted at any time.
        </ListItem>
        <ListItem sx={{ pl: 0 }}>
          Pets are welcome as long as the following guidelines are observed:
          <List
            sx={{
              listStyleType: "circle",
              pl: 2,
              "& .MuiListItem-root": {
                display: "list-item",
              },
            }}
          >
            <ListItem sx={{ pl: 0 }}>
              Keep your pets on a short leash and under your control at all
              times.
            </ListItem>
            <ListItem sx={{ pl: 0 }}>
              Ensure your pet does not disturb other campers (remember, some
              people are afraid of dogs).
            </ListItem>
            <ListItem sx={{ pl: 0 }}>
              Do not leave your pet unattended at any time.
            </ListItem>
            <ListItem sx={{ pl: 0 }}>Pick up after your dog.</ListItem>
            <ListItem sx={{ pl: 0 }}>
              Pets are not allowed on the beach. They are welcome to swim to the
              left of the beach by the boat launch / docks.
            </ListItem>
          </List>
        </ListItem>
      </List>
      <Typography
        gutterBottom
        sx={{ backgroundColor: "#ffee90", p: 2, mx: "0.7%" }}
      >
        Campground staff have the right to evict anyone from the campground who
        fails to observe any of the above requirements.
      </Typography>
    </div>
  );
};
